// extracted by mini-css-extract-plugin
export default {"userTable":"Actual_userTable__HB4qm","paginationContainer":"Actual_paginationContainer__AWO0N","rc-pagination-options":"Actual_rc-pagination-options__rE4Nx"};